import { gql } from '@apollo/client';

export const ADMIN_GET_PERSON = gql`
  query User($personId: Int!) {
    user(personId: $personId) {
      id
      records {
        id
      }
      siblings {
        id
        name
        photoUrl
      }
      parents {
        id
        name
        photoUrl
      }
      children {
        id
        name
        photoUrl
      }
      photoUrl
      buddies {
          id
          name
          photoUrl
      }
      currentCourseAttendances {
        attendance {
            id
            status
        }
        courseId
        course {
            id
            name
            SKU
            overseers {
                id
                name
                photoUrl
            }
        }
      }
      isArchived
      uploadURLSmall
      scriptName
      haveRegistrationDocument
      registrationDocumentUrl
      preferredName
      identifier
      name
      dob
      tags {
        id
        name
      }
      address
      attendancePercentage
      truency
      picturePermission
      coursesTeaching {
        id
        name
        SKU
      }
      courses {
        id
        name
        SKU
      }
    }
  }
`;
